export const ROLE_ADMIN = 'admin'
export const ROLE_PARTNER = 'partner'
export const ROLE_GATE_MANAGER = 'gate_manager'
export const ROLE_AGENCE = 'agence'

export const rolesSuggestion = [
  {
    "value": ROLE_ADMIN,
    "label": "Admin"
  },
  {
    "value": ROLE_PARTNER,
    "label": "Partner"
  },
  {
    "value": ROLE_GATE_MANAGER,
    "label": "Gate Manager"
  },
  {
    "value": ROLE_AGENCE,
    "label": "Agence"
  }
]
